
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  on: {
    pageInit: function (e, page) {
      var self = this;
      var app = self.$app;
      var $page = self.$$(page.el);
      self.calendarModal = app.calendar.create({
        inputEl: '#demo-calendar-modal',
        openIn: 'customModal',
        header: true,
        footer: true,
        dateFormat: 'yyyy/mm/dd'
      });
      var $input = $page.find('#profileAvatarInput');
      var $img = $page.find('#profileAvatarImg');
      var $fallback = $page.find('.profile-avatar-fallback');
      $page.on('click', '#profileAvatarEdit', function () {
        $input[0].click();
      });
      $input.on('change', function () {
        var file = this.files && this.files[0];
        if (!file)
          return;
        if (!/^image\/(jpeg|png|webp)$/.test(file.type)) {
          app.dialog.alert('Please choose a JPG, PNG or WebP image.', 'Unsupported file');
          $input.val('');
          return;
        }
        if (file.size > 5 * 1024 * 1024) {
          app.dialog.alert('Image must be 5 MB or smaller.', 'Too large');
          $input.val('');
          return;
        }
        var fd = new FormData();
        fd.append('avatar', file);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', app.data.remoteUrl + 'user/avatar', true);
        xhr.setRequestHeader('Accept', 'application/json');
        var token = localStorage.getItem('token');
        if (token)
          xhr.setRequestHeader('mdoc-token', token);
        app.preloader.show();
        xhr.onload = function () {
          app.preloader.hide();
          $input.val('');
          var resp = null;
          try {
            resp = JSON.parse(xhr.responseText);
          } catch (_) {
          }
          if (xhr.status >= 200 && xhr.status < 300 && resp && resp.status && resp.data && resp.data.avatar_url) {
            var url = resp.data.avatar_url + (resp.data.avatar_url.indexOf('?') === -1 ? '?' : '&') + 't=' + Date.now();
            $img.attr('src', url).css('display', '');
            $fallback.css('display', 'none');
            localStorage.setItem('avatar_url', resp.data.avatar_url);
            app.data.user.avatar = resp.data.avatar_url;
            if (app.methods.invalidateHomeCache)
              app.methods.invalidateHomeCache();
            app.toast.create({
              text: 'Profile photo updated',
              closeTimeout: 1800,
              position: 'bottom'
            }).open();
            return;
          }
          if (resp && resp.msg) {
            app.dialog.alert(resp.msg, 'Error');
          } else {
            app.methods.requestError(xhr);
          }
        };
        xhr.onerror = function () {
          app.preloader.hide();
          $input.val('');
          app.methods.requestError(xhr);
        };
        xhr.send(fd);
      });
    },
    pageBeforeRemove() {
      var self = this;
      if (self.calendarModal)
        self.calendarModal.destroy();
    }
  },
  id: '0d32222ee4',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page profile-edit-page" data-name="edit-profile">\n        <div class="navbar">\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back" aria-label="Back">\n                        <i class="icon icon-back"></i>\n                        <span class="if-not-md">Back</span>\n                    </a>\n                </div>\n                <div class="title">My Profile</div>\n            </div>\n        </div>\n        <div class="page-content">\n\n            <!-- Hero header with avatar -->\n            <div class="profile-hero">\n                <div class="profile-hero-avatar" id="profileAvatarWrap">\n                    ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.avatar_url, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <img id="profileAvatarImg" src="';
          r += c(ctx_2.data.avatar_url, ctx_2);
          r += '" alt="Profile photo" onerror="this.style.display=\'none\'; this.parentNode.querySelector(\'.profile-avatar-fallback\').style.display=\'inline-flex\';">\n                    <span class="profile-avatar-fallback" style="display:none;">\n                        <i class="icon f7-icons if-not-md">person_fill</i>\n                        <i class="icon material-icons md-only">person</i>\n                    </span>\n                    ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '\n                    <img id="profileAvatarImg" src="" alt="Profile photo" style="display:none;">\n                    <span class="profile-avatar-fallback">\n                        <i class="icon f7-icons if-not-md">person_fill</i>\n                        <i class="icon material-icons md-only">person</i>\n                    </span>\n                    ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n                    <button type="button" class="profile-avatar-edit" id="profileAvatarEdit" aria-label="Change profile photo">\n                        <i class="icon f7-icons if-not-md">camera_fill</i>\n                        <i class="icon material-icons md-only">photo_camera</i>\n                    </button>\n                </div>\n                <input type="file" id="profileAvatarInput" accept="image/jpeg,image/png,image/webp" style="display:none;">\n                <div class="profile-hero-name" id="loginUserName">';
      r += c(ctx_1.data.name, ctx_1);
      r += '</div>\n                ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.data.mobile, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n                <div class="profile-hero-meta">';
          r += c(ctx_2.data.mobile, ctx_2);
          r += '</div>\n                ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            </div>\n\n            <form id="editProfileForm" class="profile-form">\n\n                <div class="profile-section-title">Personal details</div>\n\n                <div class="profile-form-field">\n                    <label class="profile-form-label" for="profileName">\n                        <i class="icon f7-icons if-not-md">person</i>\n                        <i class="icon material-icons md-only">person</i>\n                        <span>Full name</span>\n                    </label>\n                    <input type="text" id="profileName" name="name" placeholder="Enter your full name" value="';
      r += c(ctx_1.data.name, ctx_1);
      r += '" required validate>\n                </div>\n\n                <div class="profile-form-field">\n                    <label class="profile-form-label">\n                        <i class="icon f7-icons if-not-md">phone</i>\n                        <i class="icon material-icons md-only">phone_android</i>\n                        <span>Mobile</span>\n                        <span class="profile-form-locked">Verified</span>\n                    </label>\n                    <input type="text" readonly value="';
      r += c(ctx_1.data.mobile, ctx_1);
      r += '">\n                </div>\n\n                <div class="profile-form-field">\n                    <label class="profile-form-label" for="profileEmail">\n                        <i class="icon f7-icons if-not-md">envelope</i>\n                        <i class="icon material-icons md-only">email</i>\n                        <span>Email</span>\n                    </label>\n                    <input type="email" id="profileEmail" name="email" placeholder="your@email.com" value="';
      r += c(ctx_1.data.email, ctx_1);
      r += '">\n                </div>\n\n                <div class="profile-form-field">\n                    <span class="profile-form-label">\n                        <i class="icon f7-icons if-not-md">person_2</i>\n                        <i class="icon material-icons md-only">wc</i>\n                        <span>Gender</span>\n                    </span>\n                    <div class="profile-gender-row">\n                        <label class="profile-gender-pill">\n                            <input type="radio" name="gender" value="Male" ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.gender == \'Male\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked=""';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                            <span>Male</span>\n                        </label>\n                        <label class="profile-gender-pill">\n                            <input type="radio" name="gender" value="Female" ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.gender == \'Female\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked=""';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                            <span>Female</span>\n                        </label>\n                        <label class="profile-gender-pill">\n                            <input type="radio" name="gender" value="Others" ';
      r += Template7Helpers.js_if.call(ctx_1, 'this.data.gender == \'Others\'', {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked=""';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                            <span>Other</span>\n                        </label>\n                    </div>\n                </div>\n\n                <div class="profile-form-field">\n                    <label class="profile-form-label" for="demo-calendar-modal">\n                        <i class="icon f7-icons if-not-md">calendar</i>\n                        <i class="icon material-icons md-only">date_range</i>\n                        <span>Date of birth</span>\n                    </label>\n                    <input type="text" id="demo-calendar-modal" name="dob" placeholder="Select date" readonly="readonly" value="';
      r += c(ctx_1.data.dob, ctx_1);
      r += '">\n                </div>\n\n                <div class="profile-form-field">\n                    <label class="profile-form-label" for="profileAddress">\n                        <i class="icon f7-icons if-not-md">house</i>\n                        <i class="icon material-icons md-only">home</i>\n                        <span>Address</span>\n                    </label>\n                    <textarea id="profileAddress" name="address" rows="2" placeholder="Your address" required validate>';
      r += c(ctx_1.data.address, ctx_1);
      r += '</textarea>\n                </div>\n\n                <button class="profile-submit-btn" type="submit">\n                    <i class="icon f7-icons if-not-md">checkmark_alt</i>\n                    <i class="icon material-icons md-only">check</i>\n                    <span>Update profile</span>\n                </button>\n            </form>\n\n            <div class="profile-bottom-spacer"></div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    